<div class="d-flex justify-content-center" v-if="showSpinner">
    <div class="spinner-border loader" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>